import { View, Text } from "react-native";
import React from "react";
import { Box, Icon, Tooltip, TooltipContent, TooltipText } from "components/ui";
import { HelpCircle } from "lucide-react-native";

interface Props {
	tip: string;
}

const HelpTooltip = ({ tip }: Props) => {
	return (
		<Tooltip
			placement="top"
			trigger={(triggerProps) => {
				return (
					<Box {...triggerProps}>
						<Icon color="$primarylight" as={HelpCircle} />
					</Box>
				);
			}}
		>
			<TooltipContent paddingVertical={6} maxWidth={200} bg="$basicwhite" borderColor="$primarylight" borderWidth={1}>
				<TooltipText fontSize={14} textAlign="center" color={"$primarylight"}>
					{tip}
				</TooltipText>
			</TooltipContent>
		</Tooltip>
	);
};

export default HelpTooltip;
